import SellmonitorRepricerLandingPage from 'components/landing/sellmonitor/RepricerLandingPage'
import SellematicsRepricerLandingPage from 'components/landing/sellematics/RepricerLandingPage'
import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'

export { getServerSideProps } from 'components/landing/sellmonitor/RepricerLandingPage'

const RepricerPage: FC = () => {
  const ctx = useUserContext()

  return ctx.theme.hostType === 'sellematics'
    ? <SellematicsRepricerLandingPage />
    : <SellmonitorRepricerLandingPage />
}

export default RepricerPage
